import { c as _c } from "react/compiler-runtime";
import type { OptionFilter } from "@spree/sdk";
import { DropdownMenuCheckboxItem } from "@/components/ui/dropdown-menu";
interface OptionDropdownContentProps {
  filter: OptionFilter;
  selectedValues: string[];
  onToggle: (id: string) => void;
}
export function OptionDropdownContent(t0) {
  const $ = _c(11);
  const {
    filter,
    selectedValues,
    onToggle
  } = t0;
  const isColorFilter = filter.kind === "color_swatch";
  let t1;
  if ($[0] !== filter.options || $[1] !== isColorFilter || $[2] !== onToggle || $[3] !== selectedValues) {
    let t2;
    if ($[5] !== isColorFilter || $[6] !== onToggle || $[7] !== selectedValues) {
      t2 = option => {
        const isSelected = selectedValues.includes(option.id);
        return <DropdownMenuCheckboxItem key={option.id} checked={isSelected} onCheckedChange={() => onToggle(option.id)} onSelect={_temp}>{isColorFilter && <span className="w-4 h-4 rounded-sm border border-gray-200 shrink-0 overflow-hidden" style={option.image_url ? {
            backgroundImage: `url(${option.image_url})`,
            backgroundSize: "cover"
          } : option.color_code ? {
            backgroundColor: option.color_code
          } : {
            backgroundColor: "#e5e7eb"
          }} />}<span className="flex-1">{option.label}</span><span className="text-xs text-muted-foreground">({option.count})</span></DropdownMenuCheckboxItem>;
      };
      $[5] = isColorFilter;
      $[6] = onToggle;
      $[7] = selectedValues;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = filter.options.map(t2);
    $[0] = filter.options;
    $[1] = isColorFilter;
    $[2] = onToggle;
    $[3] = selectedValues;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <>{t1}</>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}
function _temp(e) {
  return e.preventDefault();
}